import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Spinner } from "@/components/UI";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Search from "@/pages/Search";
import CardDetail from "@/pages/CardDetail";
import Sets from "@/pages/Sets";
import SetDetail from "@/pages/SetDetail";
import Collection from "@/pages/Collection";
import { Goals, Wishlist } from "@/pages/Goals";
import { Pokedex, PokemonCards } from "@/pages/Pokedex";
import Scan from "@/pages/Scan";
import Settings from "@/pages/Settings";
import Family from "@/pages/Family";
import FamilyCards from '@/pages/FamilyCards';
import Admin from "@/pages/Admin";
import CustomSets from "@/pages/CustomSets";
import CustomSetDetail from "@/pages/CustomSetDetail";
import Storage, { StorageDetail } from "@/pages/Storage";
import PersonalSetDetail from "@/pages/PersonalSetDetail";
import PrintChecklist from "@/pages/PrintChecklist";
import { CardPreferencesProvider } from "@/components/CardBrowser";
import FoilPreview from '@/pages/FoilPreview';
import FamilyShared from '@/pages/FamilyShared';

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <CardPreferencesProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/search" element={<Search />} />
            <Route path="/card/:id" element={<CardDetail />} />
            <Route path="/sets" element={<Sets />} />
            <Route path="/sets/:id" element={<SetDetail />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/goals" element={<Navigate to="/my-sets" replace />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/family" element={<Family />} />
            <Route path="/family/cards" element={<FamilyCards />} />
            <Route path="/family/:ownerId/sets/:kind/:id" element={<FamilyShared />} />
            <Route path="/family/:ownerId/storage/:id" element={<FamilyShared storage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/my-sets" element={<CustomSets />} />
            <Route path="/my-sets/:kind/:id/print" element={<PrintChecklist />} />
            <Route path="/my-sets/:kind/:id" element={<PersonalSetDetail />} />
            <Route path="/my-sets/:id" element={<CustomSetDetail />} />
            <Route path="/storage" element={<Storage />} />
            <Route path="/storage/:id" element={<StorageDetail />} />
            <Route path="/pokedex" element={<Pokedex />} />
            <Route path="/pokedex/:dex" element={<PokemonCards />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/foil-preview" element={<FoilPreview />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      </CardPreferencesProvider>
    </AuthProvider>
  );
}
